import { Paragraph as GrommetParagraph } from 'grommet'
import styled from 'styled-components'

const StyledParagraph = styled(GrommetParagraph)`
  font-family: Roboto;
  color: ${props => (props.color ? props.color : 'black')};
`

export { StyledParagraph }
